/**
 * Tipos de widget
 */
export enum WidgetType {
  HISTORY = 'HISTORY',
  TITLES = 'TITLES',
  ANTHEM = 'ANTHEM',
  UNIFORM = 'UNIFORM',
}

/**
 * Situação do widget
 */
export enum WidgetStatus {
  /**
   * Criada
   */
  CREATED = 'CREATED',
}

/**
 * Destino de abertura de um `hyperlink` no app.
 *
 * Espelha o enum `HyperlinkTarget` do types-sdk. Toda entidade que guarda um
 * `hyperlink` guarda junto um `hyperlink_target` dizendo COMO o app deve abri-lo.
 */
export enum HyperlinkTarget {
  /**
   * Navegador externo do dispositivo
   */
  EXTERNAL = 'EXTERNAL',
  /**
   * WebView interna do app
   */
  INTERNAL = 'INTERNAL',
  /**
   * WebView do parceiro (BaladApp)
   */
  PARTNER = 'PARTNER',
}
